export default __webpack_public_path__ + "static/media/Miscellaneous10.75afb627.jpg";